import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getDropdownExtractForecastFromSAPSlice = createApi(`GetDropdownExtractForecastFromSAPSlice`,"GET");

const GetDropdownExtractForecastFromSAPSlice = createSlice({
  name: 'GetDropdownExtractForecastFromSAPSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDropdownExtractForecastFromSAPSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDropdownExtractForecastFromSAPSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDropdownExtractForecastFromSAPSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetDropdownExtractForecastFromSAPSlice.reducer;